import React from 'react';

import Text from '~/components/core/TextComponents/Text';
import { serverDateTimeToLocal } from '~/DateTimeUtils';

interface CommunicationDateTimeSectionProps {
  communicationDateTime?: string;
}

const CommunicationDateTimeSection: React.FC<CommunicationDateTimeSectionProps> = ({ communicationDateTime }) => (
  <div className="flex flex-col items-end justify-center gap-2">
    <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.REGULAR}>
      {communicationDateTime ? serverDateTimeToLocal(communicationDateTime) : ''}
    </Text>
  </div>
);

export default CommunicationDateTimeSection;
